import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @title}}\n  <title>{{@title}}</title>\n{{/if}}\n<path d=\"M8 14V8H14V6H8V0H6V6H0V8H6V14H8Z\" fill=\"black\" fill-opacity=\"0.9\"></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/plus.hbs"
});